import withStyles from '@material-ui/core/styles/withStyles';
import LoadingGif from "assets/img/loading.gif";
import propTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import { default as React } from 'react';

const styles = {};

export const Loading = (props) => {
    const { color, isLoading } = props;
    return <div style={{ padding: '0.5rem', height: '2rem' }}>
        {isLoading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: color }}>
            <img src={LoadingGif} style={{ width: '1rem', height: '1rem' }} alt='loadinggif' />
            <span style={{ marginLeft: '0.4rem', fontStyle: 'italic', color: 'gray' }}>読み込み中
            </span>
        </div>}
    </div>;
}
Loading.defaultProps = {
    color: 'black',
    isLoading: true,
}
Loading.propTypes = {
    color: propTypes.oneOf(['white', 'black']),
    isLoading: propTypes.bool
}
export const LoadingIcon = ({
    color = 'black',
    size = 20,
}: {
    color?: string,
    size?: number
}) => {
    return <div style={{ padding: '0.5rem' }}>
    <CircularProgress size={size} />
</div>;
}

export default withStyles(styles, { withTheme: true })(Loading)